import { ParseXml } from '../../api/converters/parseXml';


/**
 * Check if the session is expired for cases where json endpoint returns XML format errors.
 */
export function isSessionExpired(data: any): boolean {
  return data['response']?.['session'] === 'offline';
}

export function parseXmlResponse(responseText: string): Record<string, any> | null {
  try {
    return ParseXml.parseString(responseText);
  } catch {
    return null;
  }
}

export function isSessionTerminated(responseText: string): boolean {
  const parsedResponse = parseXmlResponse(responseText);
  return parsedResponse?.response?.session === 'terminated';
}
